import { useState } from 'react';
import { ExamTaskGroupSolutionDownloadProvider } from '../Context/ExamTaskGroupSolutionDownload.context';
import { DownloadExamTaskGroupSolution } from '../models/assessment.types';
import { DownloadType } from '../pages/Assessment/Assessment.types';
import CardsDownloader from './CardsDownloader.component';

export interface CardsDownloaderContainerProps {
  pageSize?: number;
  assessmentSessionId: string;
  processTypeId: number;
  onRender: (onDownloadStart: (downloadType: DownloadType) => void) => void;
  onDownloadStart?: () => void;
  onDownloadFinish: (downloadType: DownloadType, response: DownloadExamTaskGroupSolution) => void;
}

const CardsDownloaderContainer: React.FC<CardsDownloaderContainerProps> = (props) => {
  const [connectionEnabled, setConnectionEnabled] = useState<boolean>(false);
  const [connected, setConnected] = useState<boolean>(false);

  return (
    <ExamTaskGroupSolutionDownloadProvider disabled={!connectionEnabled} onConnectionChanged={setConnected}>
      <CardsDownloader
        processTypeId={props.processTypeId}
        pageSize={props.pageSize}
        assessmentSessionId={props.assessmentSessionId}
        onDownloadStart={() => setConnectionEnabled(true)}
        onDownloadFinish={(downloadType, response) => {
          setConnectionEnabled(false);
          props.onDownloadFinish && props.onDownloadFinish(downloadType, response);
        }}
        onRender={props.onRender}
        connected={connected}
      >
        {props.children}
      </CardsDownloader>
    </ExamTaskGroupSolutionDownloadProvider>
  );
};

export default CardsDownloaderContainer;
